export const bubbleLoaderStyle = `
.bubble-loader > span {
  width: 15px;
  height: 15px;
  background-color: transparent;
  border: 3px solid hsl(var(--primary));
  border-radius: 50%;
  display: inline-block;
  animation: pulse 1.1s infinite ease-in-out;
  animation-fill-mode: both;
}

.bubble-loader .bubble1 {
  animation-delay: 0s;
}

.bubble-loader .bubble2 {
  animation-delay: 0.15s;
}

.bubble-loader .bubble3 {
  animation-delay: 0.3s;
}

@keyframes pulse {
  0%,
  80%,
  100% {
    transform: scale(0.3);
    opacity: 0.2;
  }
  40% {
    transform: scale(0.5);
    opacity: 1;
  }
}`;

export const customScrollbarStyle = `
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #CBD5E1;
    border-radius: 3px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94A3B8;
  }
`;
